import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { FaStar } from "react-icons/fa";
import './ClientReview.css';
import FashionLookBook from "../components/FashionLookBook";

const reviews = [
  {
    img: "https://randomuser.me/api/portraits/women/1.jpg",
    name: "Jane Doe",
    review: "Amazing products and excellent customer service!",
    rating: 5,
  },
  {
    img: "https://randomuser.me/api/portraits/men/2.jpg",
    name: "John Smith",
    review: "I love shopping here. Highly recommended!",
    rating: 4,
  },
  {
    img: "https://randomuser.me/api/portraits/women/3.jpg",
    name: "Alice Johnson",
    review: "Fast delivery and quality products. Will buy again!",
    rating: 5,
  },
];

function ClientReview() {
  return (
    <>
    <FashionLookBook />
    
    <section className="client-review-section py-5 bg-light">
      <div className="container">
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 3000 }}
          loop={true}
          spaceBetween={30}
          slidesPerView={1} // Always 1 card visible
        >
          {reviews.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="review-card text-center p-4 shadow-sm">
                <img src={item.img} alt={item.name} className="review-img mb-3"  data-aos="zoom-in"/>
                <h5 className="mb-2">{item.name}</h5>
                <p className="mb-2 review-text">{item.review}</p>
                <div className="review-stars">
                  {Array.from({ length: item.rating }).map((_, i) => (
                    <FaStar key={i} color="#FFD700"  data-aos="fade-up"
     data-aos-anchor-placement="top-bottom"/>
                  ))}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
    </>
  );
}

export default ClientReview;
